import { render, staticRenderFns } from "./reply.vue?vue&type=template&id=36d4b104&"
import script from "./reply.vue?vue&type=script&lang=js&"
export * from "./reply.vue?vue&type=script&lang=js&"
import style0 from "./reply.vue?vue&type=style&index=0&id=36d4b104&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports